import React, { useState } from "react";
import Icon1 from "../icons/Icon.js";
import { getDocument } from "pdfjs-dist";
import SecondaryButton from "../buttons/SecondaryButton.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import PrimaryButton from "../buttons/PrimaryButton.js";
import { useSnackbar } from "notistack";
import Space from "../layout/Space.js";
import TextField2 from "../textfields/TextField2.js";
import "@react-pdf-viewer/core/lib/styles/index.css";
import getTemporaryUrl from "../api/getTemporaryUrl.js";
import { getDocDataById, updateDocDataField } from "../models/DataFunctions.js";
import { getOrgById } from "../models/OrgFunctions.js";
import { useEffect } from "react";
import sign from "../api/sign/sign.js";
import { useAppContext } from "../config/AppContext.js";
import SmallSpinner from "../loading/SmallSpinner.js";
import PdfViewer from "./model/PdfViewer.js";
import { useRef } from "react";

import { addActivityLog } from "../config/OnlineStatus.js";
import PDFViewerGPT1 from "./new_sign/PDFViewerGPT1.js";
import TextField2T from "../textfields/TextField2T.js";
import DropDownGPT03 from "../dropdowns/DropDownGTP03.js";
import { checkAndSendTriggerEvent } from "../config/TriggerEmailSystem.js";
import Modal1 from "../modals/Modal1.js";
import DropzoneImage from "../dropzones/DropZoneImage.js";
import uploadDropZoneTemporary from "../api/upload/uploadDropZoneTemporary.js";
import sendOrgSignature from "../api/sign/sendOrgSignature.js";

const HS2 = ({
  document,
  folder,
  orgData,
  userData,
  onClose,
  overrideId,
  navigateWorkspace,
}) => {
  const [step, setStep] = useState("choice");
  const [pdfDimensions, setPdfDimensions] = useState({ width: 0, height: 0 }); // Track actual PDF dimensions
  const [allfields, setAllFields] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [path, setPath] = useState("");
  const [url, setUrl] = useState("");
  const [champs, setChamps] = useState(document.champs || []);
  const [localdocument, setLocalDocument] = useState(document);
  const selectedFileName = localdocument.files[0].name;
  const pdfContainerRef = useRef(null); // Reference to the PDF container
  const [tampon_index, setTamponIndex] = useState(null);
  const [sign_index, setSignIndex] = useState(null);
  const [consentGiven, setConsentGiven] = useState(false);
  const forDPE = document?.documentxx?.id === "IGjNsygZZjmq7ucUirV6";
  const [newSignatureOpen, setNewSignatureOpen] = useState(false);
  const [newTamponOpen, setNewTamponOpen] = useState(false);
  const [dropped_files, setDroppedFiles] = useState([]);
  const [loadingDrop, setLoadingDrop] = useState(false);
  const [droppedExists, setDroppedExists] = useState(false);
  const [signatureName, setSignatureName] = useState("");

  const handleOpenSign = () => {
    setStep("sign");
  };
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const fillAutoSign = (champs, autosign, autotampon) => {
    for (let champ of champs) {
      if (champ.type === "Signature" && autosign != null) {
        if (autosign !== "") {
          champ.content = autosign;
          if (isValidUrl(autosign)) {
            champ.imgPath = autosign;
          }
        }
      } else if (champ.type === "Tampon" && autotampon != null) {
        if (autotampon !== "") {
          champ.content = autotampon;
          if (isValidUrl(autotampon)) {
            champ.imgPath = autotampon;
          }
        }
      }
    }
    setChamps(champs);

    return champs; // Return the modified list
  };

  // Helper function to validate URLs

  const addTamponAll = (champs, url, tampon) => {
    // Loop through the list of champs
    for (let champ of champs) {
      if (champ.type === "Tampon" && tampon) {
        // Set the image and content to the provided URL for Tampon
        champ.imgPath = url;
        champ.content = url;
      }
      if (champ.type === "Signature" && !tampon) {
        // Set the image and content to the provided URL for Signature
        champ.imgPath = url;
        champ.content = url;
      }
    }
    return champs; // Return the modified list
  };

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [signatures, setSignatures] = useState([]);
  const [signatures_options, setSignatures_options] = useState([]);
  const [tampons, setTampons] = useState([]);
  const [tampons_options, setTampons_options] = useState([]);

  const fetchurls = async () => {
    let signature_options = (orgData.config?.signatures || []).map(
      (sign, index) => {
        return { value: index, label: sign.name };
      }
    );
    setSignatures(orgData.config?.signatures || []);
    setSignatures_options(signature_options || []);

    setTampons_options(
      (orgData.config?.tampons || []).map((tampon, index) => {
        return { value: index, label: tampon.name };
      })
    );
    setTampons(orgData.config?.tampons || []);

    const token = await getOrRefreshFirebaseToken();
    await getTemporaryUrl(token, "all", document.id, folder.id, prefix);
    const newdocument = await getDocDataById("document", document.id);
    setLocalDocument(newdocument);
    fillAutoSign(newdocument.champs, null, null);
  };

  useEffect(() => {
    fetchurls();
  }, []);

  const onChangeTextField = (e, label, index) => {
    const updatedChamps = champs.map((champ, i) => {
      if (champ.label === label && index === i) {
        return {
          ...champ, // Spread the current champ properties
          content: e.target.value, // Update the content
        };
      }
      return champ; // Return unchanged champ for other labels
    });

    setChamps(updatedChamps); // Set the updated array as state
  };

  const [loadingData, setLoadingData] = useState(false);

  const handleSign = async () => {
    try {
      if (sign_index === null || tampon_index === null) {
        handleClickVariant(
          "Veuillez ajouter une signature et un tampon",
          "error"
        );
        return;
      }
      let new_champs = fillAutoSign(
        champs,
        signatures[sign_index].url,
        tampons[tampon_index].url
      );
      if (new_champs.some((champ) => champ.content === "")) {
        handleClickVariant(
          "Veuillez remplir tous les champs avant de signer",
          "error"
        );
        return;
      }
      setLoadingData(true);
      const url = localdocument.files[0].url;
      const { width, height } = pdfDimensions;
      const token = await getOrRefreshFirebaseToken();
      const folderId = folder.id;

      await sign(
        new_champs,
        height,
        width,
        url,
        token,
        folderId,
        document.id,
        overrideId,
        prefix,
        selectedFileName,
        forDPE,
        consentGiven
      );
      await addActivityLog(
        "Document signé " + (document.name || ""),
        folder.ref,
        orgData.id,
        userData.id,
        "document_signed",
        prefix
      );

      handleClickVariant("Attestation signée avec succès", "success");
      onClose();
      setLoadingData(false);
    } catch (error) {
      handleClickVariant(
        "Une erreur s'est produite. Merci de réessayer ultérieurement.",
        "error"
      );
    }
  };

  const selectedFileUrl =
    localdocument.files[localdocument.files.length - 1].url;

  // Callback to set the PDF dimensions (width and height) from PdfViewer
  const handlePdfLoad = async () => {
    if (selectedFileUrl) {
      const loadingTask = getDocument(selectedFileUrl);
      const pdf = await loadingTask.promise;

      // Get the total number of pages
      const numPages = pdf.numPages;

      // Ensure that all pages are rendered (this will vary depending on your PDF rendering logic)
      // Get the height of the container that has all pages
      const container = pdfContainerRef.current;

      if (container) {
        const totalHeightInCssPixels = container.scrollHeight; // This gives the total scrollable height in CSS pixels

        // Calculate the height per page in CSS pixels
        const pageHeightInCssPixels = totalHeightInCssPixels / numPages;

        // You can also update state to store these values
        setPdfDimensions({
          width: container.clientWidth, // Use the width of the container in CSS pixels
          height: pageHeightInCssPixels, // Set the per-page height in CSS pixels
        });
      }
    }
  };

  const onDropZone = async (files) => {
    setLoadingDrop(true);
    const token = await getOrRefreshFirebaseToken();

    let new_files = [];

    new_files = files.filter(
      (file) => !dropped_files.map((filed) => filed.name).includes(file.name)
    );

    let new_drop_files = [];

    for (let i = 0; i < new_files.length; i++) {
      let res = await uploadDropZoneTemporary(
        token,
        new_files[i],
        new_files[i].name,
        prefix
      );
      let url = res.url;
      let name = res.name;
      new_drop_files = [...new_drop_files, { url: url, name: name }];
    }
    let new_dropped_files = [...dropped_files, ...new_drop_files];
    setDroppedFiles(new_dropped_files);
    setDroppedExists(true);

    setLoadingDrop(false);
  };

  const onDelete = (file) => {
    setDroppedFiles((prevFiles) => prevFiles.filter((f) => f !== file));
    if (dropped_files.length === 0) {
      setDroppedExists(false);
    }
  };

  const handleCreateSignature = async (istampon = false) => {
    const token = await getOrRefreshFirebaseToken();
    await sendOrgSignature(
      dropped_files[0],
      signatureName,
      orgData.id,
      istampon,
      token,
      prefix
    );
    if (istampon) {
      handleClickVariant("Tampon ajouté", "success");
    } else {
      handleClickVariant("Signature ajoutée", "success");
    }
    setNewTamponOpen(false);
    setNewSignatureOpen(false);
    setSignatureName("");
    setDroppedFiles([]);
    setDroppedExists(false);

    // Fetch updated org data and refresh signatures/tampons
    const updatedOrgData = await getOrgById(orgData.id);

    let signature_options = (updatedOrgData.config?.signatures || []).map(
      (sign, index) => {
        return { value: index, label: sign.name };
      }
    );
    setSignatures(updatedOrgData.config?.signatures || []);
    setSignatures_options(signature_options || []);

    setTampons_options(
      (updatedOrgData.config?.tampons || []).map((tampon, index) => {
        return { value: index, label: tampon.name };
      })
    );
    setTampons(updatedOrgData.config?.tampons || []);

    // Auto-select the newly created signature or tampon
    if (istampon) {
      const newTamponIndex = (updatedOrgData.config?.tampons || []).length - 1;
      setTamponIndex(newTamponIndex);
    } else {
      const newSignatureIndex = (updatedOrgData.config?.signatures || []).length - 1;
      setSignIndex(newSignatureIndex);
    }
  };

  return (
    <>
      <Modal1
        isOpen={newSignatureOpen}
        onClose={() => {
          setNewSignatureOpen(false);
          setSignatureName("");
          setDroppedFiles([]);
          setDroppedExists(false);
        }}
      >
        <div className="bg-white rounded-xl p-4 h-fit w-c500 flex flex-col gap-2">
          <div className="text-h2  text-left mb-2">
            Ajouter une nouvelle signature
          </div>
          <div className="text-h3 text-indigo-600 bg-indigo-50 p-3 rounded-lg border-l-4 border-indigo-300">
            Cette signature sera enregistrée et disponible pour toutes vos futures signatures.
          </div>
          <DropzoneImage
            loading={loadingDrop}
            files={dropped_files}
            onDrop={onDropZone}
            onDelete={onDelete}
          ></DropzoneImage>{" "}
          <TextField2T
            label="Nom de la signature"
            className="w-c400"
            value={signatureName}
            onChange={(e) => setSignatureName(e.target.value)}
            transparent={false}
            mandatory={true}
          ></TextField2T>
          <div className="flex flex-row justify-between mt-4">
            <SecondaryButton
              onClick={() => {
                setNewSignatureOpen(false);
                setSignatureName("");
                setDroppedFiles([]);
                setDroppedExists(false);
              }}
            >
              Annuler
            </SecondaryButton>
            <PrimaryButton
              className="w-fit  "
              disabled={signatureName === "" || dropped_files.length === 0}
              onClick={() => handleCreateSignature(false)}
            >
              Enregistrer
            </PrimaryButton>
          </div>
        </div>
      </Modal1>
      <Modal1
        isOpen={newTamponOpen}
        onClose={() => {
          setNewTamponOpen(false);
          setSignatureName("");
          setDroppedFiles([]);
          setDroppedExists(false);
        }}
      >
        <div className="bg-white rounded-xl p-4 h-fit w-c500 flex flex-col gap-2">
          <div className="text-h2  text-left mb-2">
            Ajouter un nouveau tampon
          </div>
          <div className="text-h3 text-indigo-600 bg-indigo-50 p-3 rounded-lg border-l-4 border-indigo-300">
            Ce tampon sera enregistré et disponible pour toutes vos futures signatures.
          </div>
          <DropzoneImage
            loading={loadingDrop}
            files={dropped_files}
            onDrop={onDropZone}
            onDelete={onDelete}
          ></DropzoneImage>
          <TextField2T
            label="Nom du tampon"
            className="w-c400"
            value={signatureName}
            onChange={(e) => setSignatureName(e.target.value)}
            transparent={false}
            mandatory={true}
          ></TextField2T>
          <div className="flex flex-row justify-between mt-4">
            <SecondaryButton
              onClick={() => {
                setNewTamponOpen(false);
                setSignatureName("");
                setDroppedFiles([]);
                setDroppedExists(false);
              }}
            >
              Annuler
            </SecondaryButton>
            <PrimaryButton
              className="w-fit  "
              disabled={signatureName === "" || dropped_files.length === 0}
              onClick={() => handleCreateSignature(true)}
            >
              Enregistrer
            </PrimaryButton>
          </div>
        </div>
      </Modal1>
      <div className="h-screen w-screen flex flex-row p-2">
        <div className="flex flex-col w-full h-full bg-white p-5 ">
          <div className="text-h2 text-black">Signature du document</div>
          <div className="flex flex-row">
            <div className="text-h3 text-shadow_50">
              Vidéo tutoriel pour apprendre à signer{" "}
            </div>
            <Space x={5}></Space>
            <Icon1 icon_name="question" fill="grey"></Icon1>
          </div>
          {/* Right section: PDF viewer */}
          <div
            id="pdf-container"
            ref={pdfContainerRef} // Assign the container ref here
            style={{
              width: "80%",
              height: "100%",
              overflowY: "auto",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "100%",
              }}
            >
              <PDFViewerGPT1 pdfUrl={selectedFileUrl}></PDFViewerGPT1>
            </div>
          </div>
        </div>
        <div className="flex flex-col h-full  py-5 pr-5 bg-white items-end ">
          <div className="w-c400  h-5/6 rounded-xl p-2 flex flex-col overflow-auto   border border-shadow_10  shadow-md">
            <div className=" p-2  rounded-xl flex flex-col h-full gap-4">
              <div className="flex flex-col flex-grow text-shadow_50 text-h2">
                <div className="flex flex-col bg-violet-50 p-4 border-l-4 rounded-xl border-indigo-300 gap-2 h-full overflow-auto">
                  Champs à remplir
                  {champs.map(
                    (champ, index) =>
                      (champ.type.toLowerCase() === "text" ||
                        champ.type.toLowerCase() === "date") && (
                        <div key={index}>
                          <TextField2T
                            transparent={false}
                            label={champ.label}
                            mandatory={true}
                            key={index}
                            value={champ.content}
                            onChange={(e) => {
                              onChangeTextField(e, champ.label, index);
                            }}
                          ></TextField2T>
                        </div>
                      )
                  )}
                  {document?.documentxx?.id === "IGjNsygZZjmq7ucUirV6" && (
                    <div className="mt-2">
                      <p className="text-h3 font-semibold mb-2">
                        Consentement à la signature :
                      </p>
                      <div className="flex flex-col gap-2 text-h4">
                        <label
                          className={`p-3 rounded-lg border-2 cursor-pointer transition-all ${
                            consentGiven === true
                              ? "border-green-600 bg-green-50"
                              : "border-gray-300 bg-white hover:bg-gray-50"
                          }`}
                        >
                          <input
                            type="radio"
                            name="consent"
                            value="yes"
                            checked={consentGiven === true}
                            onChange={() => setConsentGiven(true)}
                            className="mr-2"
                          />
                          Oui, je consens à signer ce document.
                        </label>

                        <label
                          className={`p-3 rounded-lg border-2 cursor-pointer transition-all ${
                            consentGiven === false
                              ? "border-red-600 bg-red-50"
                              : "border-gray-300 bg-white hover:bg-gray-50"
                          }`}
                        >
                          <input
                            type="radio"
                            name="consent"
                            value="no"
                            checked={consentGiven === false}
                            onChange={() => setConsentGiven(false)}
                            className="mr-2"
                          />
                          Non, je ne consens pas à signer ce document.
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Signature and Tampon row positioned at the bottom */}
              <div className="flex flex-col gap-2 h-fit">
                <div className=" bg-violet-50 p-4 border-l-4 border-indigo-300 rounded-xl h-fit flex flex-col gap-2 mt-auto ">
                  <div className="flex flex-row gap-2">
                    <SecondaryButton
                      className={"w-fit"}
                      onClick={() => {
                        setSignatureName(orgData.name);
                        setNewSignatureOpen(true);
                      }}
                    >
                      Ajouter une signature
                    </SecondaryButton>
                    <SecondaryButton
                      className={"w-fit"}
                      onClick={() => {
                        setSignatureName(orgData.name);
                        setNewTamponOpen(true);
                      }}
                    >
                      Ajouter un tampon
                    </SecondaryButton>
                  </div>
                  <div className="flex flex-col gap-2   h-full text-h2 text-shadow_50">
                    <DropDownGPT03
                      items={signatures_options}
                      label="Signature"
                      value={sign_index}
                      onChange={(option) => {
                        setSignIndex(option.value);
                      }}
                      mandatory={true}
                    ></DropDownGPT03>
                    <div className="flex border-1 border-shadow_50 w-40  h-24  rounded-xl   overflow-hidden">
                      {signatures[sign_index]?.url && (
                        <img
                          src={signatures[sign_index]?.url}
                          className="object-contain  w-40 h-24 rounded-xl"
                        ></img>
                      )}
                    </div>
                  </div>
                  <div className="flex flex-col gap-2 w-full h-full text-h2 text-shadow_50">
                    <DropDownGPT03
                      items={tampons_options}
                      className="w-full"
                      label="Tampon"
                      value={tampon_index}
                      onChange={(option) => setTamponIndex(option.value)}
                      mandatory={true}
                    ></DropDownGPT03>

                    <div className="flex border-1 border-shadow_50 rounded-xl w-40  h-24  overflow-hidden">
                      {tampons[tampon_index]?.url && (
                        <img
                          src={tampons[tampon_index]?.url}
                          className="object-contain  w-40  h-24 rounded-xl"
                          alt="Tampon"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
          <div className="relative py-2 px-2 gap-2   place-content-end flex flex-row ">
            <SecondaryButton onClick={onClose}>Annuler</SecondaryButton>
            <PrimaryButton
              className="w-fit"
              disabled={
                loadingData || sign_index === null || tampon_index === null
              }
              onClick={handleSign}
            >
              <div className="flex flex-row content-center align-middle items-center">
                Signer le document <Space x={5} />
                <SmallSpinner loading={loadingData} margin={0} size={20} />
              </div>
            </PrimaryButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default HS2;

export const isValidUrl = (string) => {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
};
